import React, {Component} from "react";
import DashboardComponent from "../components/DashboardComponent";

export class Dashboard extends Component{
    render(){
        return(
            <DashboardComponent />
        )
    }
}

export default Dashboard;